"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetamoduleAttachmentSides = void 0;
/**
 * Indicates which side of an object a metamodule is attached to in canvas space.
 */
var MetamoduleAttachmentSides;
(function (MetamoduleAttachmentSides) {
    MetamoduleAttachmentSides["LEFT"] = "Left";
    MetamoduleAttachmentSides["RIGHT"] = "Right";
    MetamoduleAttachmentSides["TOP"] = "Top";
    MetamoduleAttachmentSides["BOTTOM"] = "Bottom";
    MetamoduleAttachmentSides["CENTER"] = "Center";
    MetamoduleAttachmentSides["TOP_RIGHT"] = "TopRight";
})(MetamoduleAttachmentSides || (exports.MetamoduleAttachmentSides = MetamoduleAttachmentSides = {}));
//# sourceMappingURL=structure.js.map